import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useContext, useMemo, useEffect } from 'react';
import { IntlContext } from '@swift-paypal/pp-react-intl';
import { TextInput } from '@swift-paypal/pp-react-text-input';
import { Combobox } from '@swift-paypal/pp-react-combobox';
import { Col, Container, Row } from '@swift-paypal/pp-react-grid';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Get address parts to display for the current locale and address region from IntlProvider
function getAddressParts(intlContext, region) {
  var partsToDisplay = {};
  var partsDisplayOrder = [];

  if (region && intlContext && intlContext.addressFormatter) {
    var addressParts = intlContext.addressFormatter({
      addressRegion: region
    }).formatToParts({});
    addressParts.forEach(function (_ref) {
      var parts = _ref.parts;
      var types = [];
      parts.forEach(function (_ref2) {
        var allowedValues = _ref2.allowedValues,
            type = _ref2.type;
        partsToDisplay[type] = {};
        partsToDisplay[type].props = {};
        types.push(type);
        /* istanbul ignore else */

        if (intlContext.getDisplayNamesObject) {
          if (allowedValues) {
            var translations = intlContext.getDisplayNamesObject({
              type: 'portableAddressValues',
              element: type,
              addressRegion: region
            });
            var options = allowedValues.map(function (allowedValue) {
              return {
                label: translations.select(allowedValue),
                value: allowedValue
              };
            });
            partsToDisplay[type].props.options = options;
            partsToDisplay[type].as = Combobox;
          }

          var labelTranslations = intlContext.getDisplayNamesObject({
            type: 'portableAddress',
            addressRegion: region
          });
          partsToDisplay[type].props.label = labelTranslations.select(type);
        }
      });

      if (types.length > 1) {
        partsDisplayOrder.push(types);
      } else {
        partsDisplayOrder.push(types[0]);
      }
    });
  }

  return {
    partsToDisplay: partsToDisplay,
    partsDisplayOrder: partsDisplayOrder
  };
}

var AddressInput = function (_ref3) {
  var region = _ref3.region,
      _ref3$parts = _ref3.parts,
      parts = _ref3$parts === void 0 ? {} : _ref3$parts,
      partsOrder = _ref3.partsOrder,
      _ref3$excludedParts = _ref3.excludedParts,
      excludedParts = _ref3$excludedParts === void 0 ? [] : _ref3$excludedParts,
      className = _ref3.className,
      fieldClassName = _ref3.fieldClassName,
      fieldNamePrefix = _ref3.fieldNamePrefix;
  var intlContext = useContext(IntlContext);
  var _partsOrder = partsOrder;

  var _useMemo = useMemo(function () {
    return getAddressParts(intlContext, region);
  }, [region]),
      partsToDisplay = _useMemo.partsToDisplay,
      partsDisplayOrder = _useMemo.partsDisplayOrder;

  if (region && !(_partsOrder && _partsOrder.length)) {
    _partsOrder = partsDisplayOrder;
  }

  if (!(_partsOrder && _partsOrder.length)) {
    _partsOrder = Object.keys(parts);
  }

  var renderPart = function (part) {
    var partObj = _objectSpread(_objectSpread({
      props: {}
    }, partsToDisplay[part]), parts[part]); //Merge props


    if (partsToDisplay[part] && parts[part]) {
      partObj.props = _objectSpread(_objectSpread({}, partsToDisplay[part].props), parts[part].props);
    }

    if (!partObj.as) {
      if (partObj.props.options) {
        partObj.as = Combobox;
      } else {
        partObj.as = TextInput;
      }
    }

    var Component = partObj.as;
    return /*#__PURE__*/React.createElement(Component, _extends({
      name: "".concat(fieldNamePrefix, "_").concat(part)
    }, partObj.props));
  };

  var rows = [];

  _partsOrder.forEach(function (part, index) {
    var columns = [];

    if (typeof part !== 'string') {
      var cols = Math.floor(12 / part.length);
      part.forEach(function (subPart, colIndex) {
        if (!excludedParts.includes(subPart)) {
          columns.push( /*#__PURE__*/React.createElement(Col, {
            sm: cols,
            xs: 12,
            className: fieldClassName,
            key: colIndex,
            form: "vspace"
          }, renderPart(subPart)));
        }
      });
    } else if (!excludedParts.includes(part)) {
      columns.push( /*#__PURE__*/React.createElement(Col, {
        xs: 12,
        className: fieldClassName,
        key: index,
        form: "vspace"
      }, renderPart(part)));
    }

    if (columns.length) {
      rows.push( /*#__PURE__*/React.createElement(Row, {
        key: index
      }, columns));
    }
  });

  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, rows);
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ADDRESS_PARTS = ['recipient', 'businessName', 'addressLine1', 'addressLine2', 'addressLine3', 'adminArea1', 'adminArea2', 'postalCode'];

var AddressInputWithValidation = function (_ref) {
  var region = _ref.region,
      validate = _ref.validate,
      _ref$parts = _ref.parts,
      parts = _ref$parts === void 0 ? {} : _ref$parts,
      _ref$requiredFieldErr = _ref.requiredFieldErrorText,
      requiredFieldErrorText = _ref$requiredFieldErr === void 0 ? 'Please enter a value' : _ref$requiredFieldErr,
      _ref$invalidFieldErro = _ref.invalidFieldErrorText,
      invalidFieldErrorText = _ref$invalidFieldErro === void 0 ? 'Please enter a valid value' : _ref$invalidFieldErro,
      address = _ref.address,
      _ref$addressErrors = _ref.addressErrors,
      addressErrors = _ref$addressErrors === void 0 ? {} : _ref$addressErrors,
      onChange = _ref.onChange,
      onValidate = _ref.onValidate,
      rest = _objectWithoutProperties(_ref, ["region", "validate", "parts", "requiredFieldErrorText", "invalidFieldErrorText", "address", "addressErrors", "onChange", "onValidate"]);

  var intlContext = useContext(IntlContext);
  var validator = region && intlContext && intlContext.addressFormatter && intlContext.addressFormatter({
    addressRegion: region
  });

  var handleChange = function (evt, part) {
    onChange(_objectSpread$1(_objectSpread$1({}, address), {}, _defineProperty({}, part, evt.target.value)));
  };

  var _parts = useMemo(function () {
    return ADDRESS_PARTS.reduce(function (acc, part) {
      acc[part] = _objectSpread$1({
        props: {}
      }, parts[part]);

      acc[part].props.onChange = function (evt) {
        return handleChange(evt, part);
      };

      acc[part].props.value = address[part] || '';
      acc[part].props.errorText = addressErrors[part];
      return acc;
    }, {});
  }, [parts]);

  var validateAddress = function () {
    var validations = [];
    var errors = {};

    if (validator) {
      validations = validator.validate(address);
      validations.forEach(function (_ref2) {
        var code = _ref2.code,
            element = _ref2.element;

        /* istanbul ignore next */
        if (_parts[element]) {
          errors[element] = code === 'MISSING_REQUIRED' ? requiredFieldErrorText : invalidFieldErrorText;
        }
      });
    }

    onValidate(errors, validations);
  };

  useEffect(function () {
    if (validate) {
      validateAddress();
    }
  }, [validate]);
  return /*#__PURE__*/React.createElement(AddressInput, _extends({
    parts: _parts,
    region: region
  }, rest));
};

export { AddressInput, AddressInputWithValidation };
